/* eslint-disable no-unused-vars */
import { useCallback, useEffect, useState } from 'react'
import { NavigateFunction, useNavigate } from 'react-router-dom'

import {
  CustomersCustomerTitleChoices,
  CustomersCustomerTypeChoices,
  useCustomerQuery,
} from '@/apollo/graphql'
import { homePath, transformData } from '@/utils'
import { ICustomer, TFormSubmit } from '@/types'
import { useAPI } from '@/hooks'

interface IUseData {
  id?: string
}

interface IUseDataRes {
  loading: boolean
  submitting: boolean
  onCancel: () => void
  onSubmit: TFormSubmit<ICustomer>
  data: Partial<ICustomer> | undefined
}

const defaultData: Partial<ICustomer> = {
  title: CustomersCustomerTitleChoices.Mr,
  type: CustomersCustomerTypeChoices.Business,
}

export const useData = ({ id }: IUseData): IUseDataRes => {
  const navigate: NavigateFunction = useNavigate()
  const { submitting, sendForm } = useAPI()
  const [data, setData] = useState<Partial<ICustomer>>(defaultData)

  const { loading, refetch } = useCustomerQuery({
    skip: !id,
    fetchPolicy: 'network-only',
    variables: {
      id: id || '',
    },
    onCompleted: res => {
      if (res.customer) {
        // @ts-ignore
        setData({
          ...(res.customer || {}),
          title: res.customer.title || CustomersCustomerTitleChoices.Mr,
          type: res.customer.type || CustomersCustomerTypeChoices.Business,
        })
      }
    },
  })

  useEffect(() => {
    setData(defaultData)
  }, [id])

  const onSubmit: TFormSubmit<ICustomer> = useCallback(
    (path, isEdit, callback) => d => {
      sendForm(
        {
          path,
          method: isEdit ? 'PUT' : 'POST',
          data: transformData(d),
          callback: e => {
            callback?.(e)
            refetch()
          },
        },
        { showNotify: true },
      )
    },
    [refetch, sendForm],
  )

  const onCancel = useCallback(() => {
    navigate(homePath)
  }, [navigate])

  return {
    data,
    loading,
    onSubmit,
    onCancel,
    submitting,
  }
}
